import Axios from 'axios'

const axios = Axios.create({
    baseURL: process.env.NEXT_PUBLIC_BACKEND_URL || 'http://localhost:8000',
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/json',
    },
    withCredentials: true,
    withXSRFToken: true,
})

axios.interceptors.response.use(
    response => response,
    async error => {
        const original = error.config
        if (
            error.response?.status === 419 &&
            original &&
            !original._csrfRetry
        ) {
            original._csrfRetry = true
            try {
                await axios.get('/sanctum/csrf-cookie')
                return axios(original)
            } catch (refreshError) {
                return Promise.reject(refreshError)
            }
        }
        return Promise.reject(error)
    },
)

export default axios
